module.exports = __webpack_public_path__ + "img/jinshukuaijiq.2172d7e0.jpg";